import React from 'react';
import Loading from '../../pages/Screens/Loading';
import UserData from '../../Models/UserData';
import { connect } from 'react-redux';
import { onCurrentUserChange } from '../../actions';
import { getCurrentUserFromToken } from '../../features/account/application/accountApi';

interface PropTypes {
  children: React.ReactElement;
  currentUser: UserData | null;
  onCurrentUserChange: (userData: UserData) => void;
}

interface StateTypes {
  initialRender: boolean;
}

class UserProvider extends React.Component<PropTypes, StateTypes> {
  constructor(props: PropTypes | Readonly<PropTypes>) {
    super(props);

    this.state = {
      initialRender: false
    };
  }

  componentDidMount(): void {
    this.setState({
      initialRender: true
    });
  }

  componentDidUpdate(
    prevProps: Readonly<PropTypes>,
    prevState: Readonly<StateTypes>
  ): void {
    if (
      this.state.initialRender === prevState.initialRender &&
      !this.state.initialRender
    ) {
      return;
    }

    if (this.props.currentUser !== null) {
      return;
    }

    // BHP-1050: bootstrap the current user from the OIDC id-token claims (the
    // reliable "who am I"), instead of the legacy backend or the accounts
    // collection (which an admin sees in full).
    const user = getCurrentUserFromToken();
    if (user !== null) {
      this.props.onCurrentUserChange(user);
    }
  }

  render(): JSX.Element {
    if (!this.state.initialRender || this.props.currentUser === null) {
      return <Loading />;
    }

    return this.props.children;
  }
}

const mapStateToProps = ({
  userReducer
}: any): { currentUser: UserData | null } => ({
  currentUser: userReducer.currentUser
});

export default connect(mapStateToProps, {
  onCurrentUserChange
})(UserProvider);
